import React from 'react';
import { FormattedMessage } from 'react-intl';

/** @type {(id: string, values?: any) => typeof FormattedMessage} */
export const text = (id, values = {}) => (
  <FormattedMessage id={id} defaultMessage='' values={values} />
);
